module.exports = __webpack_public_path__ + "img/octopus.e4b72676.png";